import { Need4SteelWizardStep, Need4SteelWizardState } from '../../models/need4steel-wizard-state';

export abstract class WizardPageContent {
	readonly stepIndex: Need4SteelWizardStep;
	constructor(stepIndex: Need4SteelWizardStep, state: Need4SteelWizardState) {
		this.stepIndex = stepIndex;
		state.errorInPage = false;
	}
	abstract checkError(): boolean;
}
